import { render, staticRenderFns } from "./FormAggregateDocuments.vue?vue&type=template&id=fcfe28c0"
import script from "./FormAggregateDocuments.vue?vue&type=script&lang=js"
export * from "./FormAggregateDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports